import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#619e42",
    },
    secondary: {
      main: "#1171c5",
    },
    info: {
      main: "#aaaaaa",
    },
  },
});

export default theme;
